import type { TFunction } from 'i18next';
import { z } from 'zod';

import { requiredStringSchema } from '@/js/libs/form';

import { PIN_LENGTH } from './constants.ts';

export const createSchema = (t: TFunction) =>
  z.object({
    pin: requiredStringSchema((schema) => schema.length(PIN_LENGTH, t('admin:TEMPORARY_ACCESS_PIN_INVALID_LENGTH'))),
  });

type Schema = ReturnType<typeof createSchema>;
export type FormValues = z.input<Schema>;
export type SubmitValues = z.output<Schema>;
